import { serialize, parse } from 'cookie';
import { v4 as uuidv4 } from 'uuid';

export function createRcxCookie(): string {
	const uuid = uuidv4();
	const TWO_YEARS_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 365 * 1; // 1 years (milliseconds, seconds, minutes, hours, days, years)
	const date = new Date();
	date.setTime(date.getTime() + TWO_YEARS_IN_MILLISECONDS);

	const rcxCookie = serialize('rcx', uuid, {
		domain: window.location.hostname,
		path: '/',
		maxAge: TWO_YEARS_IN_MILLISECONDS,
		expires: date,
		secure: true,
	});

	return rcxCookie;
}

export function getRcxCookieValue(documentCookie: string): string {
	const { rcx } = parse(documentCookie);

	if (typeof rcx === 'undefined') {
		const rcxCookie = createRcxCookie();
		document.cookie = rcxCookie;
		const { rcx: parsedRcx } = parse(rcxCookie);
		return parsedRcx;
	}

	return rcx;
}

export function getNativeRcxCookie(): string {
	return getRcxCookieValue(document.cookie);
}
